import React, {useEffect, useState} from "react";
import {useLocation, useParams} from "react-router-dom";
import RedirectMobileModal from "./RedirectMobileModal";
const DeepLinkRedirector = () => {
  const [show, setShow] = useState(false);
  const location = useLocation();
  const {id} = useParams();
  useEffect(() => {
    // Check if the user is on a mobile device
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    const noRedirectMobile = localStorage.getItem("noRedirectMobile");
    if (isMobile && !noRedirectMobile) {
      setShow(true);
    } else {
      return;
    }
  }, []);

  const redirect = () => {
    const pathParts = location.pathname
      .split("/")
      .filter((part) => part !== "");

    // Get the second-to-last element (index -2) and the last element (index -1)
    const type =
      pathParts?.length > 1
        ? pathParts[pathParts.length - 2]
        : pathParts[pathParts.length - 1]; // second-to-last
    const id = pathParts[pathParts.length - 1]; // last

    // if (isMobile) {
    let appScheme;

    // Set the appropriate scheme based on the type of link
    switch (type) {
      case "annonce":
        appScheme = `helpclic://AnnouncementDetail/${id}`;
        break;
      case "intervention":
        appScheme = `helpclic://InterventionDetail/${id}`;
        break;
      case "messages":
        appScheme = `helpclic://Chatroom/${location.hash}`;
        break;
      case "mon-profil":
        appScheme = "helpclic://Profile";
        break;
      default:
        appScheme = "helpclic://";
        return; // Exit if an invalid type is provided
    }

    const fallbackUrl = window.location.href;

    // Try to open the app first
    const openApp = () => {
      window.location.href = appScheme;
    };

    // Detect if the app was opened successfully
    let appOpened = false;
    window.addEventListener("blur", () => {
      appOpened = true;
    });

    // If the app wasn't opened after a short delay, redirect to app store
    setTimeout(() => {
      if (!appOpened) {
        // Determine app store based on device
        if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
          window.location.href = "https://apps.apple.com/app/your-app-id"; // Replace with your App Store URL
        } else if (/Android/i.test(navigator.userAgent)) {
          window.location.href =
            "https://play.google.com/store/apps/details?id=com.helpclic"; // Replace with your Play Store URL
        }
      }
    }, 2000);

    openApp();
    // }
  };

  // Component doesn't render anything visible
  return (
    <>
      <RedirectMobileModal
        show={show}
        setShow={setShow}
        title={"HelpClic est encore mieux en app !"}
        message={
          "Disponible sur iOS & Android Installez pour une expérience fluide"
        }
        buttonTitle={"Oui"}
        secondButtonTitle={"Non"}
        handelButton={() => {
          setShow(false);
          redirect();
        }}
        handelSecondButton={() => {
          setShow(false);
          localStorage.setItem("noRedirectMobile", true);
        }}
      />
    </>
  );
};

export default DeepLinkRedirector;
